import { z } from "zod";
import { paginationSchema } from "./common.js";
export const profileQuerySchema = paginationSchema.extend({
    tab: z.enum(["network", "ledger", "redemptions", "scans", "dispatches"]).default("network"),
    role: z.enum(["sales_rep", "distributor", "sub_distributor", "counter", "karigar"]).optional(),
    status: z.string().trim().max(50).optional(),
});
//# sourceMappingURL=userProfile.js.map